export default "__VITE_ASSET__100ccb07__"